import { notificationService } from '@app/services/notification.service';
import { t } from 'i18next';

/**
 * Opens antd notification based on the standardized error object.
 */
export const apiErrorHandler = (error: any) => {
	notificationService.error({ ...error });
};

/**
 * Builds a standardized error object from an Axios response or error object.
 */
export const getErrorData = (response: any) => {
	const error = {
		message: t('api.error'),
		description: '',
		status: 405,
	};

	// API Timeout.
	if (response?.code === 'ECONNABORTED') {
		error.status = 408;
		error.description = t('common.notifications.apiRequestTimeout');
		return error;
	}

	if (response?.status) {
		// Override status if available.
		error.status = response.status;

		// User's token is not valid.
		if (response?.status === 401) {
			error.message = t('common.notifications.userTokenInvalid');
		}

		// Wrong API call url.
		if (response?.status === 404) {
			error.description = t('common.notifications.serverError');
		}

		// Server conflict errors.
		if (response?.status === 409 && Array.isArray(response?.response?.data)) {
			error.description = response.response.data
				.map((item: any) => `${item.Номенклатура} ${item.Конфликт}`)
				.join(', ');
		}
	}

	// Custom error from API if available.
	if (
		response.response?.data?.error &&
		response.response?.data?.error !== '' &&
		typeof response.response?.data?.error === 'string'
	) {
		if (response.response?.data) {
			error.message = response.response?.data.error;
		}
	}

	return error;
};
